type ElAttrs = {
  className?: string;
  dataset?: Record<string, string>;
  [key: string]: unknown;
};

type ElChild = string | Node | null | undefined;


export const $ = <T extends Element = Element>(sel: string, parent?: Element | Document): T | null =>
  (parent || document).querySelector<T>(sel);

export const $$ = <T extends Element = Element>(sel: string, parent?: Element | Document): T[] =>
  [...(parent || document).querySelectorAll<T>(sel)];

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: ElAttrs = {},
  children: ElChild | ElChild[] = []
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  for (const [key, val] of Object.entries(attrs)) {
    if (key === 'className') node.className = val as string;
    else if (key === 'dataset') Object.assign(node.dataset, val);
    else if (key.startsWith('on'))
      node.addEventListener(
        key.slice(2).toLowerCase(),
        val as EventListener
      );
    else if (val !== undefined && val !== null)
      node.setAttribute(key, String(val));
  }

  for (const child of ([] as ElChild[]).concat(children)) {
    if (child == null) continue;
    node.appendChild(
      typeof child === 'string' ? document.createTextNode(child) : child
    );
  }
  return node;
}

/** Replace all children of target with the given nodes */
export function mount(target: Element, ...nodes: (Node | null | undefined)[]): void {
  target.innerHTML = '';
  nodes.filter(Boolean).forEach((n) => target.appendChild(n as Node));
}
